import { Component, Prop, Vue } from 'vue-property-decorator';
import { PLAN_LIMITS_LOGIC } from '@/services/constants/planLimits';
 
@Component
export default class PlanLimitsMixin extends Vue {
  isChangePlanDialogLoading=false

  planLimitsKeysGrouping = [
    {
      name: `${this.t('Data retention')} (${this.t('months')})`,
      keys:[
        'dataRetention',
      ]
    },
    {
      name: this.t('Number of Active Elements'),
      keys:[
        'campaignsAmount',
        'offersAmount',
        'landingsAmount',
        'flowsAmount',
        'trafficSourcesAmount',
        'affiliateNetworksAmount',
      ]
    },
    {
      name: this.t('Domains'),
      keys:[
        'domainsAmount',
        'redirectDomainsAmount'
      ]
    },
    {
      name: this.t('Traffic Distribution'),
      keys:[
        'externalIdCondition',
        'webViewCondition',
        'crawlerCondition',
        'proxyCondition',
        'referrerDomainCondition',
        'botMarkCondition',
        'uniquenessPeriodCondition',
        'visitCapCondition',
        'uniqOfferViewerCondition',
      ]
    },
    {
      name: this.t('Bulk Edit'),
      keys:[
        'bulkEditCampaigns',
        'bulkEditOffers',
        'bulkEditLandings'
      ]
    },
    {
      name: this.t('Import Settings'),
      keys:[
        'importOffers',
        'importLandings',
      ]
    },
    {
      name: this.t('Bulk Reports'),
      keys:[
        'bulkReportCampaign',
        'bulkReportOffer',
        'bulkReportLanding',
        'bulkReportFlow',
        'bulkReportAffiliateNetwork',
        'bulkReportTrafficSource',
        'bulkReportCustomParams',
        'bulkReportBrowserNames',
        'bulkReportBrowserVersions',
        'bulkReportCities',
        'bulkReportConnectionTypes',
        'bulkReportCountries',
        'bulkReportDay',
        'bulkReportDayOfWeek',
        'bulkReportDeviceModels',
        'bulkReportDeviceTypes',
        'bulkReportDeviceVendors',
        'bulkReportHourOfDay',
        'bulkReportIp',
        'bulkReportIsp',
        'bulkReportLanguages',
        'bulkReportMobileCarriers',
        'bulkReportMonth',
        'bulkReportOs',
        'bulkReportOsVersions',
        'bulkReportReferrerDomains',
        'bulkReportReferrers',
        'bulkReportScreenResolutions',
        'bulkReportStatesRegions',
        'bulkReportSubnetBig',
        'bulkReportSubnetSmall',
        'bulkReportUserAgents',
      ]
    },
    {
      name: this.t('Marks'),
      keys:[
        'markersCampaigns',
        'markersOffers',
        'markersLandings',
        'markersFlows',
        'markersAffiliateNetworks',
        'markersTrafficSources',
        'markersCustomParams'
      ]
    },
    {
      name: this.t('Team Work'),
      keys:[
        'memberAdminsAmount',
        'memberUsersAmount',
        'sharedReportsAmount',
      ]
    },
    {
      name: this.t('Tags'),
      keys:[
        'tagsCampaigns',
        'tagsOffers',
        'tagsLandings',
        'tagsFlows',
        'tagsAffiliateNetworks',
        'tagsTrafficSources'
      ]
    },
    {
      name: this.t('Integrations'),
      keys:[
        'integrationMgid',
        'integrationExoclick',
        'integrationPropellerads',
        'integrationRevcontent',
        'integrationFacebookConversions',
        'integrationTrafficjunky'
      ]
    },
    {
      name: this.t('Advanced Settings'),
      keys:[
        'sendPostbacksCampaign',
        'trafficLossCampaign',
        'customColumnsAmount',
        'customConversionsAmount',
        'botFiltersAccess',
        'doubleMetaRedirect',
        'uniquenessPeriod',
        'landingPageProtection',
        'trafficSourceParamMasking',
        'smartRotations',
        'presetAmount',
        'compareReport'
      ]
    },
    {
      name: this.t('Invalid Traffic Tracking'),
      nameHelp: this.t('Activate the metrics to track the suspicious traffic. <br> The data on each metric will be displayed in the separate column of suspicious visits, clicks, impressions in your reports.'),
      keys:[
        'ivtIpIsDatacenter',
        'ivtIpIsBlacklisted',
        'ivtFastClicker',
        'ivtIpWithFrequentCampaignEvents',
        'ivtIpWithFrequentEvents'
      ]
    }
  ] as {
    name: string;
    nameHelp?: string;
    keys: string[];
  }[]
  
  @Prop()
  planLimits: keyof BillingLimits | {
    logic: PLAN_LIMITS_LOGIC.AT_LEAST_ONE_REQUIRED | PLAN_LIMITS_LOGIC.ALL_REQUIRED
    addons: (keyof BillingLimits)[]
  }
  
  @Prop({default:false})
  planLimitsEditable;
  
  hasAddonRestriction(planLimit){
    if(typeof this.$PL[planLimit] === 'number'){
      const {limits, usage } = this.$store.state.billing;
      return +limits[planLimit] <= +usage[planLimit]
    }

    return this.$PL[planLimit]===false
  }
  
  hasPlanLimitsRestriction(planLimits ){
    if((planLimits?.logic)){
      const addons = []

      planLimits.addons.forEach((planLimit)=>{
        addons.push(this.hasAddonRestriction(planLimit))
      });
      
      if(planLimits.logic===PLAN_LIMITS_LOGIC.ALL_REQUIRED){
        return addons.some((item)=>item===true);
      }
      
      if(planLimits.logic===PLAN_LIMITS_LOGIC.AT_LEAST_ONE_REQUIRED){
        return !addons.some((item)=>item===false);
      }
    }
    
    return this.hasAddonRestriction(planLimits)
  }

  get showPlanLimitsIcon() {
    return this.hasPlanLimitsRestriction(this.planLimits)
  }


  handleClickPlanLimits(planLimits = this.planLimits) {
    if(this.hasPlanLimitsRestriction(planLimits) && !this.isChangePlanDialogLoading && !this.planLimitsEditable){
      
      if(this.$store.state.user.isMember){
        return this.bus.emit('toast-error', this.t('The option is not available on your plan. Contact the account owner to upgrade and get the access.'));
      }
      
      this.isChangePlanDialogLoading=true;
      return this.bus.emit('open-dialog',{
        name: 'ChangePlanDialog',
        data: { 
          planLimits: planLimits, 
          actionAfterLoad:()=>{this.isChangePlanDialogLoading=false}
        }
      });
    }
  }

  get planLimitsKeyText() {
    return {
      eventsAmount: this.t('Events'),
      dataRetention: this.t('Data retention'),
      domainsAmount: this.t('Tracking domains'),
      campaignsAmount: this.t('Campaigns'),
      offersAmount: this.t('Offers'),
      landingsAmount: this.t('Landing pages'),
      flowsAmount: this.t('Flows'),
      trafficSourcesAmount: this.t('Traffic sources'),
      affiliateNetworksAmount: this.t('Affiliate networks'),
      customColumnsAmount: this.t('Custom columns'),
      memberAdminsAmount: this.t('Admins'),
      memberUsersAmount: this.t('Users'),
      redirectDomainsAmount: this.t('Cloaking domains'),
      customConversionsAmount: this.t('Custom conversions'),
      sharedReportsAmount: this.t('Shared reports'),
      bulkEditCampaigns: this.t('Access to campaigns bulk edit'),
      bulkEditOffers: this.t('Access to offers bulk edit'),
      bulkEditLandings: this.t('Access to landings bulk edit'),
      webViewCondition: this.t('Webview condition for traffic distribution'),
      crawlerCondition: this.t('Crawler condition for traffic distribution'),
      proxyCondition: this.t('Proxy condition for traffic distribution'),
      externalIdCondition: this.t('External ID Condition For Traffic Distribution'),
      referrerDomainCondition: this.t('Referrer domain condition for traffic distribution'),
      botMarkCondition: this.t('Bot mark condition for traffic distribution'),
      uniquenessPeriodCondition: this.t('Uniqueness condition for traffic distribution'),
      visitCapCondition : this.t('Visit Cap condition for traffic distribution'),
      doubleMetaRedirect: this.t('Double meta redirect'),
      uniquenessPeriod: this.t('Uniqueness period in campaign settings'),
      bulkReportCampaign: this.t('Bulk reports on campaigns'),
      bulkReportOffer: this.t('Bulk reports on offers'),
      bulkReportLanding: this.t('Bulk reports on landings'),
      bulkReportFlow: this.t('Bulk reports on flows'),
      bulkReportTrafficSource: this.t('Bulk reports on traffic sources'),
      bulkReportAffiliateNetwork: this.t('Bulk reports on affiliate networks'),
      bulkReportCustomParams: this.t('Bulk reports on Custom Params'),
      importOffers: this.t('Import offers from the file'),
      importLandings: this.t('Import landings from the file'),
      markersCampaigns: this.t('Marks for campaigns'),
      markersOffers: this.t('Marks for offers'),
      markersLandings: this.t('Marks for landings'),
      markersFlows: this.t('Marks for flows'),
      markersAffiliateNetworks: this.t('Marks for affiliate networks'),
      markersTrafficSources: this.t('Marks for traffic sources'),
      markersCustomParams: this.t('Marks for custom params'),
      sendPostbacksCampaign: this.t('Send postbacks % in campaign'),
      trafficLossCampaign: this.t('Traffic loss % in campaigns'),
      landingPageProtection: this.t('Landing page protection'),
      tagsCampaigns: this.t('Tags for campaigns'),
      tagsOffers: this.t('Tags for offers'),
      tagsLandings: this.t('Tags for landings'),
      tagsFlows: this.t('Tags for flows'),
      tagsTrafficSources: this.t('Tags for traffic sources'),
      tagsAffiliateNetworks: this.t('Tags for affiliate networks'),
      trafficSourceParamMasking: this.t('Ghost ID (Traffic Source Values Masking)'),
      botFiltersAccess: this.t('Access to bot filters'),
      integrationMgid: this.t('Integration with MGID'),
      integrationExoclick: this.t('Integration with Exoclick'),
      integrationTrafficjunky: this.t('Integration with TrafficJunky'),
      integrationPropellerads : this.t('Integration with PropellerAds'),
      integrationFacebookConversions : this.t('Integration with Facebook'),
      integrationRevcontent: this.t('Integration with Revcontent'),
      smartRotations: this.t('Smart Rotations'),
      presetAmount: this.t('Presets'),
      ivtIpIsDatacenter: this.t('IPs from data centers'),
      ivtIpIsBlacklisted: this.t('IPs from black lists'),
      ivtFastClicker: this.t('Fast Clicks'),
      ivtIpWithFrequentEvents: this.t('Frequent Events'),
      ivtIpWithFrequentCampaignEvents: this.t('Frequent Campaign Events'),
      bulkReportBrowserNames: this.t('Bulk reports on Browsers Names'),
      bulkReportBrowserVersions: this.t('Bulk reports on Browsers Versions'),
      bulkReportCities: this.t('Bulk reports on Cities'),
      bulkReportConnectionTypes: this.t('Bulk reports on Connection Types'),
      bulkReportCountries: this.t('Bulk reports on Countries'),
      bulkReportDay: this.t('Bulk reports on Day'),
      bulkReportDayOfWeek: this.t('Bulk reports on Day Of Week'),
      bulkReportDeviceModels: this.t('Bulk reports on Device Models'),
      bulkReportDeviceTypes: this.t('Bulk reports on Device Types'),
      bulkReportDeviceVendors: this.t('Bulk reports on Device Vendors'),
      bulkReportHourOfDay: this.t('Bulk reports on Hour of Day'),
      bulkReportIp: this.t('Bulk reports on IPs'),
      bulkReportIsp: this.t('Bulk reports on ISP'),
      bulkReportLanguages: this.t('Bulk reports on Languages'),
      bulkReportMobileCarriers: this.t('Bulk reports on Mobile Carriers'),
      bulkReportMonth: this.t('Bulk reports on Month'),
      bulkReportOs: this.t('Bulk reports on OS'),
      bulkReportOsVersions: this.t('Bulk reports on OS Versions'),
      bulkReportReferrerDomains: this.t('Bulk reports on Referrer Domains'),
      bulkReportReferrers: this.t('Bulk reports on Referrers'),
      bulkReportScreenResolutions: this.t('Bulk reports on Screen Resolutions'),
      bulkReportStatesRegions: this.t('Bulk reports on State/ Region'),
      bulkReportSubnetBig: this.t('Bulk reports on Subnet Big'),
      bulkReportSubnetSmall: this.t('Bulk reports on Subnet Small'),
      bulkReportUserAgents: this.t('Bulk reports on User Agent'),
      uniqOfferViewerCondition: this.t('Recurring Conversion Condition'),
      compareReport: this.t('Compare Reports'),
    };
  }

  get planLimitsKeyTextShort() {
    return {
      ...this.planLimitsKeyText,
      webViewCondition: this.t('Webview Condition'),
      uniqOfferViewerCondition: this.t('Recurring Conversion Condition'),
      crawlerCondition: this.t('Crawler Condition'),
      proxyCondition: this.t('Proxy Condition'),
      externalIdCondition: this.t('External ID'),
      referrerDomainCondition: this.t('Referrer Domain Condition'),
      botMarkCondition: this.t('Bot Mark Condition'),
      uniquenessPeriodCondition: this.t('Uniqueness Period Condition'),
      visitCapCondition: this.t('Visit Cap Condition'),
      bulkEditCampaigns: this.t('Campaigns'),
      bulkEditOffers: this.t('Offers'),
      bulkEditLandings: this.t('Landings'),
      importOffers: this.t('Offers'),
      importLandings: this.t('Landings'),
      bulkReportCampaign: this.t('Campaigns'),
      bulkReportOffer: this.t('Offers'),
      bulkReportLanding: this.t('Landings'),
      bulkReportFlow: this.t('Flows'),
      bulkReportCustomParams: this.t('Custom Params'),
      bulkReportAffiliateNetwork: this.t('Affiliate Networks'),
      bulkReportTrafficSource: this.t('Traffic Sources'),
      markersCampaigns: this.t('Campaigns'),
      markersOffers: this.t('Offers'),
      markersLandings: this.t('Landings'),
      markersFlows: this.t('Flows'),
      markersAffiliateNetworks: this.t('Affiliate Networks'),
      markersTrafficSources: this.t('Traffic Sources'),
      markersCustomParams: this.t('Custom Params'),
      memberAdminsAmount: this.t('Admins'),
      memberUsersAmount: this.t('Users'),
      sharedReportsAmount: this.t('Shared Reports'),
      tagsCampaigns: this.t('Campaigns'),
      tagsOffers: this.t('Offers'),
      tagsLandings: this.t('Landings'),
      tagsFlows: this.t('Flows'),
      tagsAffiliateNetworks: this.t('Affiliate Networks'),
      tagsTrafficSources: this.t('Traffic Sources'),
      sendPostbacksCampaign: this.t('Share Conversions %'),
      botFiltersAccess: this.t('Bot Rules Access'),
      uniquenessPeriod: this.t('Uniqueness Period'),
      trafficSourceParamMasking: this.t('Ghost ID (Traffic Source Values Masking)'),
      bulkReportBrowserNames: this.t('Browsers Names'),
      bulkReportBrowserVersions: this.t('Browsers Versions'),
      bulkReportCities: this.t('Cities'),
      bulkReportConnectionTypes: this.t('Connection Types'),
      bulkReportCountries: this.t('Countries'),
      bulkReportDay: this.t('Day'),
      bulkReportDayOfWeek: this.t('Day Of Week'),
      bulkReportDeviceModels: this.t('Device Models'),
      bulkReportDeviceTypes: this.t('Device Types'),
      bulkReportDeviceVendors: this.t('Device Vendors'),
      bulkReportHourOfDay: this.t('Hour of Day'),
      bulkReportIp: this.t('IPs'),
      bulkReportIsp: this.t('ISP'),
      bulkReportLanguages: this.t('Languages'),
      bulkReportMobileCarriers: this.t('Mobile Carriers'),
      bulkReportMonth: this.t('Month'),
      bulkReportOs: this.t('OS'),
      bulkReportOsVersions: this.t('OS Versions'),
      bulkReportReferrerDomains: this.t('Referrer Domains'),
      bulkReportReferrers: this.t('Referrers'),
      bulkReportScreenResolutions: this.t('Screen Resolutions'),
      bulkReportStatesRegions: this.t('State/ Region'),
      bulkReportSubnetBig: this.t('Subnet Big'),
      bulkReportSubnetSmall: this.t('Subnet Small'),
      bulkReportUserAgents: this.t('User Agent'),
      integrationMgid: 'MGID',
      integrationExoclick: 'Exoclick',
      integrationTrafficjunky: 'TrafficJunky',
      integrationPropellerads :'PropellerAds',
      integrationFacebookConversions :'Facebook',
      integrationRevcontent: 'Revcontent',
    };
  }
  
  conditionPlanLimits(condition){
    switch (condition) {
      case 'webViewMark':
        return 'webViewCondition'
      case 'uniqOfferViewer':
        return 'uniqOfferViewerCondition'
      case 'externalId':
        return 'externalIdCondition'
      case 'crawler':
        return 'crawlerCondition'
      case 'proxy':
        return 'proxyCondition'
      case 'visitCap':
        return 'visitCapCondition'
      case 'botMark':
        return 'botMarkCondition'
      case 'referrerDomain':
        return 'referrerDomainCondition'
      case 'uniqueness':
        return 'uniquenessPeriodCondition'
      case 'ipDataCenter':
        return 'ivtIpIsDatacenter'
      case 'ipBlacklisted':
        return 'ivtIpIsBlacklisted'
      case 'ipWithFrequentEvents':
        return 'ivtIpWithFrequentEvents'
      case 'ipWithFrequentCampaignEvents':
        return 'ivtIpWithFrequentCampaignEvents'
    }
  }
  
  integrationsPlanLimits(condition){
    switch (condition) {
      case 'propeller':
        return 'integrationPropellerads'
      case 'revcontent':
        return 'integrationRevcontent'
      case 'mgid':
        return 'integrationMgid'
      case 'exoclick':
        return 'integrationExoclick'
      case 'trafficjunky':
        return 'integrationTrafficjunky'
      case 'facebook-conversions':
        return 'integrationFacebookConversions'
    }
  }
}